<div *ngIf="!isServer" class="section-acknowledge">
  <div class="checkbox" *ngIf="requiresSimpleInsuredAcknowledgement">
    <input
      type="checkbox"
      class="checkbox__input"
      id="insuredHasAcknowledgedCheckbox"
      value="insuredHasAcknowledgedValue"
      [disabled]="isAdvisor || isDisabled"
      [(ngModel)]="insuredHasAcknowledged"
      (change)="triggerAcknowledgeInsured()"
    />
    <div class="label-basic">
      <label
        class="checkbox__label checkbox__label--dark checkbox__label--large label-basic__text"
        for="insuredHasAcknowledgedCheckbox"
        [class.text-disable]="isDisabled"
      >
        I, {{ insuredName }}, acknowledge that I:
      </label>
      <tooltip *ngIf="isAdvisor" [helpText]="helpText"></tooltip>
    </div>
  </div>

  <div class="checkbox" *ngIf="requiresOwnerAcknowledgement">
    <input
      type="checkbox"
      class="checkbox__input"
      id="ownerHasAcknowledgedCheckbox"
      value="ownerHasAcknowledgedValue"
      [disabled]="isAdvisor || isLifeBridge || isDisabled"
      [(ngModel)]="ownerHasAcknowledged"
      (change)="triggerAcknowledgeOwner()"
    />
    <div class="label-basic">
      <label
        class="checkbox__label checkbox__label--dark checkbox__label--large label-basic__text"
        for="ownerHasAcknowledgedCheckbox"
        [class.text-disable]="isDisabled"
      >
        I, {{ ownerName }}, acknowledge that I:
      </label>
      <tooltip *ngIf="isAdvisor" [helpText]="helpText"></tooltip>
    </div>
  </div>

  <div class="checkbox" *ngIf="requiresJointOwnerAcknowledgement">
    <input
      type="checkbox"
      class="checkbox__input"
      id="otherOwnerHasAcknowledgedCheckbox"
      value="otherOwnerHasAcknowledgedValue"
      [disabled]="isAdvisor || isDisabled"
      [(ngModel)]="otherOwnerHasAcknowledged"
      (change)="triggerAcknowledgeOtherOwner()"
    />
    <div class="label-basic">
      <label
        class="checkbox__label checkbox__label--dark checkbox__label--large label-basic__text"
        for="otherOwnerHasAcknowledgedCheckbox"
        [class.text-disable]="isDisabled"
      >
        I, {{ otherOwnerName }}, acknowledge that I:
      </label>
      <tooltip *ngIf="isAdvisor" [helpText]="helpText"></tooltip>
    </div>
  </div>

  <ul [class.text-disable]="isAdvisor || isDisabled">
    <li *ngIf="contractState !== 'CA'" class="margin-bottom">
      <p>
        <span>Have reviewed and agree to the</span>
        <a
          href="common/pdf/Acknowledge-Electronic-Signature-Use-and-Hardware-Software-Requirements.pdf"
          target="_blank"
          class="section-acknowledge__text-link"
          [class.text-disable]="isAdvisor || isDisabled"
        >
          Electronic Signature Use and Hardware/Software Requirements.
        </a>
      </p>
    </li>
    <li class="margin-bottom">
      <p>
        <span>Have reviewed and agree to:</span>
      </p>

      <ul class="acknowledge-docs">
        <ng-container *ngIf="contractState === 'CA'">
          <ng-container *ngIf="!isMMD; then Cas_CA_EOpt; else MMD_CA_EOpt"></ng-container>
        </ng-container>
        <li>
          <a
            [class.text-disable]="isAdvisor || isDisabled"
            href="common/pdf/Acknowledge-Privacy-Notice.pdf"
            target="_blank"
          >
            Privacy Notice
          </a>
        </li>
        <ng-container *ngIf="contractState === 'MA'; then MA_Notice; else defaultNotice"></ng-container>
        <li>
          <a
            [class.text-disable]="isAdvisor || isDisabled"
            href="common/pdf/Acknowledge-Pre-Authorized-Payment-Form.pdf"
            target="_blank"
          >
            Premium Payment Service Terms
          </a>
        </li>
      </ul>
    </li>
    <li>
      <p class="margin-bottom">
        <span>
          Have reviewed and agreed to the following authorizations, which allow us to reach out to pharmacies, pharmacy
          benefit managers, health providers, motor vehicle departments and other organizations to request any health or
          driving records on the person who is applying for coverage. Don’t worry, any information we gather won't be
          re-disclosed without your approval unless required or permitted by law.
        </span>
      </p>
      <ul class="acknowledge-docs">
        <li>
          <a
            [class.text-disable]="isAdvisor || isDisabled"
            *ngIf="contractState !== 'CA'"
            href="{{
              policy.isICCApplication()
                ? 'common/pdf/Acknowledge-Authorization-of-proposed-Insured-to-Obtain-and-Disclose-Information-ICC.pdf'
                : 'common/pdf/Acknowledge-Non-ICC-Authorization-of-proposed-Insured-to-Obtain-and-Disclose-Information.pdf'
            }}"
            target="_blank"
          >
            Authorization to Obtain and Disclose Information
          </a>
          <a
            [class.text-disable]="isAdvisor || isDisabled"
            *ngIf="contractState === 'CA'"
            href="common/pdf/Acknowledge-CA-Authorization-of-proposed-Insured-to-Obtain-and-Disclose-Information.pdf"
            target="_blank"
          >
            Authorization to Obtain and Disclose Information
          </a>
        </li>
        <li>
          <a
            [class.text-disable]="isAdvisor || isDisabled"
            href="{{
              policy.isICCApplication()
                ? 'common/pdf/Acknowledge-HIPAA-Authorizaion-ICC.pdf'
                : 'common/pdf/Acknowledge-HIPAA-Authorization-Non-ICC.pdf'
            }}"
            target="_blank"
          >
            HIPAA Authorization
          </a>
        </li>
        <li *ngIf="contractState === 'MA'">
          <a
            [class.text-disable]="isAdvisor || isDisabled"
            href="common/pdf/Acknowledge-Consumer-Notification,-Summary-of-Consumer-Right-and-Medical-Information-Bureau-Notice.pdf"
            target="_blank"
          >
            Consumer Notification, Summary of Consumer Right and Medical Information Bureau Notice
          </a>
        </li>
      </ul>
    </li>
  </ul>
</div>

<!-- Form templates for ngIf expressions -->
<ng-template #Cas_CA_EOpt>
  <li>
    <a
      [class.text-disable]="isAdvisor || isDisabled"
      href="common/pdf/Acknowledge-CA-EOPT-Approved-CoverPath.pdf"
      target="_blank"
    >
      California Electronic Opt-In
    </a>
  </li>
</ng-template>

<ng-template #MMD_CA_EOpt>
  <li>
    <a
      [class.text-disable]="isAdvisor || isDisabled"
      href="common/pdf/Acknowledge-CA-EOPT-Approved-CoverPath.pdf"
      target="_blank"
    >
      California Electronic Opt-In
    </a>
  </li>
</ng-template>

<ng-template #MA_Notice>
  <li>
    <a
      [class.text-disable]="isAdvisor || isDisabled"
      href="common/pdf/Acknowledge-Notice-of-Information-Practices-N170DTCCP(3_18-MA).pdf"
      target="_blank"
    >
      Notice of Information Practices
    </a>
  </li>
</ng-template>

<ng-template #defaultNotice>
  <li>
    <a
      [class.text-disable]="isAdvisor || isDisabled"
      href="common/pdf/Notice-Acknowledgement-N170-10.9.20.pdf"
      target="_blank"
    >
      Notice of Information Practices
    </a>
  </li>
</ng-template>
